import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-086995ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wxcontainer" }
const _hoisted_2 = { class: "wxtip-txt" }
const _hoisted_3 = { class: "wxtip-txt-1" }
const _hoisted_4 = { class: "wxtip-txt-1" }
const _hoisted_5 = { class: "wxcontainer" }
const _hoisted_6 = { class: "wxtip-txt" }
const _hoisted_7 = { class: "wxtip-txt-1" }
const _hoisted_8 = { class: "wxtip-txt-1" }
const _hoisted_9 = { class: "wxcontainer" }
const _hoisted_10 = { class: "wxtip-txt" }
const _hoisted_11 = { class: "wxtip-txt-1" }
const _hoisted_12 = { class: "wxtip-txt-1" }

import DeviceEnvUtil from '../../utils/DeviceEnvUtil';
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'UnsupportOpenPage',
  props: {
    show_tip: { type: Boolean }
  },
  emits: ['dimiss'],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;
const { t } = useI18n();

const showWxTip = ref(false);
const showWbTip = ref(false);
const showQQTip = ref(false);

onMounted(() => {
  if (DeviceEnvUtil.isWeixin()) {
    showWxTip.value = true;
    showWbTip.value = false;
    showQQTip.value = false;
  } else if (DeviceEnvUtil.isQQ()) {
    showWxTip.value = false;
    showWbTip.value = false;
    showQQTip.value = true;
  } else if (DeviceEnvUtil.isWeibo()) {
    showWxTip.value = false;
    showWbTip.value = true;
    showQQTip.value = false;
  }
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dismiss = (event: any) => {
  event.stopPropagation();
  emit('dimiss');
};

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "unsupportTip",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (dismiss($event)))
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('tip.unsupportedOpenInApp.weixin.title')), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('tip.unsupportedOpenInApp.weixin.step1')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('tip.unsupportedOpenInApp.weixin.step2')), 1)
    ], 512), [
      [_vShow, showWxTip.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)('tip.unsupportedOpenInApp.qq.title')), 1),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)('tip.unsupportedOpenInApp.qq.step1')), 1),
      _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)('tip.unsupportedOpenInApp.qq.step2')), 1)
    ], 512), [
      [_vShow, showQQTip.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_9, [
      _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)('tip.unsupportedOpenInApp.weibo.title')), 1),
      _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(t)('tip.unsupportedOpenInApp.weibo.step1')), 1),
      _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)('tip.unsupportedOpenInApp.weibo.step2')), 1)
    ], 512), [
      [_vShow, showWbTip.value]
    ])
  ], 512)), [
    [_vShow, _ctx.show_tip]
  ])
}
}

})